import React from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
    },
    container: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    paper: {
      background: 'linear-gradient(180deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 81%, rgba(0,212,255,1) 100%);'
    },
  }));

export default function NoMatch() {
    const classes = useStyles();
    
      return (
        <>
          <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth={false} className={classes.container}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        You've gone to a page that doesn't exist.
                    </Paper>
                </Grid>
              </Grid>
            </Container>
          </main>
        </>
      );
    }
  